<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div i18n class="detail-label flex-grow-1">Deposited To</div>
    <div i18n class="detail-value">{{ accountName }}</div>
  </div>
</div>
